import { DOCUMENT } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { computed, inject, Injectable } from '@angular/core';

import { ConfigService } from '@/core/services/config';
import { UserService } from '@/core/services/user.service';

@Injectable({
  providedIn: 'root',
})
export class HijackService {
  readonly #http = inject(HttpClient);
  readonly #configService = inject(ConfigService);
  readonly #userService = inject(UserService);
  readonly #window = inject(DOCUMENT).defaultView;

  readonly isHijacked = computed(
    () => this.#userService.userData()?.isHijacked ?? false
  );
  readonly hijackedUserEmail = computed(
    () => this.#userService.userData()?.email ?? ''
  );
  readonly hijackedUserName = computed(
    () => this.#userService.userData()?.name ?? ''
  );

  /** The user taken over may lack access to the current page, so load the start page. */
  acquire(userId: number): void {
    const apiUrl = this.#configService.readConfig().API_URL;
    this.#http
      .post(`${apiUrl}/hijack/acquire/`, `user_pk=${userId}`, {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded',
        }),
        responseType: 'text',
        withCredentials: true,
      })
      .subscribe({
        error: () => this.#window?.location.assign('/'),
        next: () => this.#window?.location.assign('/'),
      });
  }

  release(): void {
    const apiUrl = this.#configService.readConfig().API_URL;
    this.#http
      .post(`${apiUrl}/hijack/release/`, '', {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded',
        }),
        responseType: 'text',
        withCredentials: true,
      })
      .subscribe({
        error: () => window.location.reload(),
        next: () => window.location.reload(),
      });
  }
}
